import * as React from 'react';
// Import react.
import { useParams } from "react-router-dom";
// Import props.
import {
	OptionalAdminSectionProps,
} from '@app/props';
// Import enumerations.
import { AdminSectionName } from '@app/enumerations';

interface UseOptionalAdminSectionPropsFromRouterResult extends OptionalAdminSectionProps {

}

const useOptionalAdminSectionPropsFromRouter = (): UseOptionalAdminSectionPropsFromRouterResult => {
	const params = useParams();

	// Parse out the router parameters for command props.
	const adminSectionName: AdminSectionName | undefined = React.useMemo(() => {
		return params['adminSectionName'] ?? undefined;
	}, [params]);

	return {
		adminSectionName
	};
}

// Export results.
export {
	UseOptionalAdminSectionPropsFromRouterResult,
}

export default useOptionalAdminSectionPropsFromRouter;